import { cn } from "@/lib/utils";
import { FileText, CreditCard, Upload, MapPin, DollarSign } from 'lucide-react';

interface StepIndicatorProps {
  currentStep: number;
  steps: {
    id: string;
    title: string;
    description: string;
    icon: keyof typeof icons;
  }[];
}

const icons = {
  personal: FileText,
  banking: CreditCard,
  documents: Upload,
  service: MapPin,
  payment: DollarSign,
};

export function StepIndicator({ currentStep, steps }: StepIndicatorProps) {
  return (
    <div className="relative mb-8">
      {/* Progress Bar */}
      <div className="absolute top-5 left-0 w-full h-0.5 bg-gray-200 dark:bg-gray-700">
        <div 
          className="h-full bg-foreground transition-all duration-300 ease-in-out"
          style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
        />
      </div>

      {/* Steps */}
      <div className="relative flex justify-between">
        {steps.map((step, index) => {
          const Icon = icons[step.icon];
          const isActive = index <= currentStep;
          
          return (
            <div 
              key={step.id}
              className={cn(
                "flex flex-col items-center space-y-2",
                isActive ? "text-foreground" : "text-muted-foreground"
              )}
            >
              <div className={cn(
                "w-10 h-10 rounded-full flex items-center justify-center bg-background border-2 transition-colors",
                isActive ? "border-foreground" : "border-muted"
              )}>
                <Icon className="h-5 w-5" />
              </div>
              <div className="text-center">
                <p className="text-sm font-medium">{step.title}</p>
                <p className="text-xs text-muted-foreground hidden sm:block">
                  {step.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}